var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// ../~/moment-timezone/index.js
// module id = 244
// module chunks = 1